module.exports = __webpack_public_path__ + "img/img_wuquanxian.91321231.png";